<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-success shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">Full Stack Development</h1>
                            <p class="lead">
                                Professionelle Webapplikationen & APIs im DACH-Raum und international
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <h2>Komplexe Webanwendungen entwickeln</h2>
                                <p>
                                    Full Stack Development bedeutet End-to-End Entwicklung: Von der Datenbank über 
                                    das Backend bis zum Frontend. Wir entwickeln skalierbare, wartbare und moderne 
                                    Webanwendungen mit bewährten Technologien und Architekturmustern.
                                </p>

                                <h3 class="mt-5">Unsere Full Stack Leistungen</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <icon name="ni ni-laptop" class="mr-2"></icon>
                                                    Web-Applikationen
                                                </h5>
                                                <p>
                                                    Von der Idee bis zur fertigen Anwendung. Wir entwickeln 
                                                    maßgeschneiderte Webanwendungen für Ihre Geschäftsprozesse.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <icon name="ni ni-settings-gear-65" class="mr-2"></icon>
                                                    API-Entwicklung
                                                </h5>
                                                <p>
                                                    RESTful APIs, GraphQL, Microservices. Wir entwickeln 
                                                    performante und sichere Schnittstellen.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <icon name="ni ni-atom" class="mr-2"></icon>
                                                    Softwarearchitektur
                                                </h5>
                                                <p>
                                                    Clean Architecture, Design Patterns, SOLID-Prinzipien. 
                                                    Fundierte Architektur für langfristigen Erfolg.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-mobile-button" class="mr-2"></icon>
                                                    Progressive Web Apps
                                                </h5>
                                                <p>
                                                    PWAs kombinieren das Beste aus Web und App. 
                                                    Offline-Funktionalität, Push-Benachrichtigungen und mehr.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">Technologie-Stack</h3>
                                <div class="mt-3">
                                    <h5 class="text-muted">Frontend</h5>
                                    <badge type="success" rounded class="mr-2 mb-2">Vue.js</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">React</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">TypeScript</badge>
                                    <badge type="success" rounded class="mr-2 mb-2">TailwindCSS</badge>
                                    
                                    <h5 class="text-muted mt-3">Backend</h5>
                                    <badge type="primary" rounded class="mr-2 mb-2">Node.js</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">TypeScript</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">PHP</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Laravel</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Symfony</badge>
                                    
                                    <h5 class="text-muted mt-3">Datenbanken & Design</h5>
                                    <badge type="warning" rounded class="mr-2 mb-2">MySQL</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">PostgreSQL</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">MongoDB</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Redis</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">Datenbankdesign</badge>
                                    <badge type="warning" rounded class="mr-2 mb-2">ER-Modellierung</badge>
                                </div>

                                <h3 class="mt-5">Softwarearchitektur & Best Practices</h3>
                                <p>
                                    Fundierte Softwarearchitektur ist das Fundament jeder erfolgreichen Anwendung. 
                                    Wir setzen auf bewährte Architekturmuster und Design Patterns, um wartbare, 
                                    skalierbare und zukunftssichere Lösungen zu entwickeln.
                                </p>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Clean Architecture</strong> - Klare Trennung von Verantwortlichkeiten
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Design Patterns</strong> - Repository, Factory, Strategy, Observer etc.
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>SOLID-Prinzipien</strong> - Wartbarer und erweiterbarer Code
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Datenbankdesign</strong> - Normalisierung, Indexierung, Performance
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>API-Design</strong> - RESTful, GraphQL, Versionierung
                                    </li>
                                </ul>

                                <h3 class="mt-5">KI-gestützte Entwicklung</h3>
                                <p>
                                    Wir nutzen moderne KI-Tools, um schneller und effizienter zu entwickeln. 
                                    Unsere Expertise in Softwarearchitektur stellt sicher, dass der generierte 
                                    Code strukturiert, wartbar und skalierbar ist - nicht chaotisch.
                                </p>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Präzise AI-Prompts mit Architekturvorgaben
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Code Reviews & Qualitätssicherung
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Testing & Dokumentation
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Refactoring & Optimierung
                                    </li>
                                </ul>

                                <h3 class="mt-5">Greenfield & Neuentwicklung</h3>
                                <p>
                                    Bei einem <strong>Greenfield-Projekt</strong> starten Sie auf der grünen Wiese – 
                                    ohne Legacy-Code, ohne technische Schulden. Das ist die Chance, von Anfang an 
                                    alles richtig zu machen: die richtige Architektur, die passenden Technologien 
                                    und ein skalierbares Datenmodell.
                                </p>
                                <div class="row mt-4">
                                    <div class="col-md-6">
                                        <h6 class="text-success">Wann Greenfield?</h6>
                                        <ul>
                                            <li>Neue Geschäftsidee / MVP</li>
                                            <li>Komplexe Datenstrukturen</li>
                                            <li>Legacy-Ablösung nicht wirtschaftlich</li>
                                            <li>Skalierbarkeit von Anfang an</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-success">Unsere Stärken</h6>
                                        <ul>
                                            <li>Domain-Driven Design (DDD)</li>
                                            <li>Clean Architecture</li>
                                            <li>ER-Modellierung & Datenbankdesign</li>
                                            <li>API-First Entwicklung</li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="success"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Jetzt Full Stack Projekt anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'fullstack',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'Full Stack Development DACH',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'Full Stack Entwicklung DACH ✓ Vue.js, React, Node.js, PHP ✓ API-Entwicklung ✓ Softwarearchitektur ✓ KI-gestützte Entwicklung ✓ 15+ Jahre Erfahrung ✓ Jetzt anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'Full Stack Entwicklung, Webentwicklung, Vue.js Entwicklung, React Entwicklung, Node.js Entwicklung, PHP Entwicklung, Laravel, API Entwicklung, Softwarearchitektur, KI-gestützte Entwicklung, Full Stack DACH'
            },
            {
                property: 'og:title',
                content: 'Full Stack Development DACH | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'Full Stack Entwicklung im DACH-Raum. Vue.js, React, Node.js, PHP, Laravel. API-Entwicklung, Softwarearchitektur & KI-gestützte Entwicklung. 15+ Jahre Erfahrung.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/full-stack'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'Full Stack Development DACH | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'Full Stack Entwicklung im DACH-Raum. Vue.js, React, Node.js, PHP, Laravel. API-Entwicklung & Softwarearchitektur.'
            }
        ]
    }
}
</script>
